import AmountToPayService from "./amount-to-pay.service";
import ClearErrorService from "./clear-error.service";
import CustomerAccountService from "./customer-account.service";
import InvoiceService from "./invoice.service";
import LookupService from "./lookup.service";
import OtpService from "./otp.service";
import PaymentService from "./payment.service";
import PermissionService from "./permission.service";
import StatementService from "./statement.service";

// const amountToPayService = new AmountToPayService();
// const clearErrorService = new ClearErrorService();
// const customerAccountService = new CustomerAccountService();
// const invoiceService = new InvoiceService();
// const lookupService = new LookupService();
// const paymentService = new PaymentService();
// const permissionService = new PermissionService();
// const statementService = new StatementService();

export {
    AmountToPayService,
    ClearErrorService,
    CustomerAccountService,
    InvoiceService,
    LookupService,
    OtpService,
    PaymentService,
    PermissionService,
    StatementService
};
